class MapFilterEditPageController {

  constructor(FiltersService, LoaderService, AlertService, $state, $stateParams) {
    this.FiltersService = FiltersService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    var self = this;
    self.validation = {};
    self.filterId = self.$stateParams.filterId;
    self.files = { 'pin' : null, 'icon': null,'home_location_filter':null};
    self.FiltersService.getById(self.filterId)
        .then( (filter) => self.filter = filter )
        .catch( (error) => self.AlertService.error("Could not get the Filter to edit") );

  }

  storeFile(picFile, type) {
    if(type === 'pin') {
      this.files.pin = picFile;
    }
    if(type === 'icon') {
      this.files.icon = picFile;
    }
    if(type === 'home_location_filter') {
        this.files.home_location_filter = picFile;
    }
  }

  save() {
    var self = this;

    if(!self.validForm()){
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.FiltersService.update(self.filter, self.files)
        .then(() => {
              self.AlertService.success("Filter has been updated");
              self.$state.go('app.map.filters', {}, { reload: true });
            }
        )
        .catch((error) => {
          self.AlertService.error("There was a problem updating the Filter")
        })
        .finally(()=> {
          // empty the file array
          self.files.splice(0, self.files.length);

          self.LoaderService.stop();
        });
  }

  deleteFilter(filterId) {
    if ( confirm("Are you sure? This cannot be undone.") ) {
      var self = this;
      self.LoaderService.start();
      self.FiltersService.deleteFilter(filterId)
          .then( () => {
            self.AlertService.success("The filter was deleted");
            self.$state.go('app.map.filters', {}, { reload: true });
          })
          .catch( (error) => self.AlertService.error("There was a problem deleting the filter. Ensure you have removed all locations from it."))
          .finally( ()=> self.LoaderService.stop() );
    }
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if(self.filter.name === undefined || self.filter.name === ''){
      self.validation.name = 'Name is required';
    }

    if(self.isEmpty(self.validation)){
      return true;
    }
    else{
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

}
MapFilterEditPageController.$inject = ['FiltersService', 'LoaderService', 'AlertService', '$state', '$stateParams'];
export default MapFilterEditPageController;
